import React, { useEffect, useState } from 'react'
import { Box, Card, CardContent, Divider, Typography } from '@material-ui/core'
import FieldInfoNG from 'asterX-UI/DataDisplay/FieldInfoNG'
import { NotFound } from 'components/NotFound/NotFound'
import { useAuthStore } from 'context/AuthStore'
import { useStyles } from './card-content.styles'

export const ContentCard = ({ title, data = [], line, columns = '5' }) => {
  const classes = useStyles()
  const { authStore } = useAuthStore()
  const [currentColumns, setCurrentColumns] = useState(authStore.isMobile ? '1' : columns)

  useEffect(() => {
    if (authStore.isMobile) {
      setCurrentColumns('1')
    } else {
      setCurrentColumns(columns)
    }
  }, [authStore.isMobile, columns])

  return (
    <Card variant="outlined" className={classes.card}>
      <CardContent className={classes.cardContent}>
        <Box display="grid" gridTemplateColumns={`repeat(${currentColumns}, 1fr)`} gap={4}>
          {title && (
            <Box gridColumn={`span ${currentColumns}`}>
              <Typography className={classes.title}>{title}</Typography>
            </Box>
          )}
          {data ? (
            data.map((item, index) => (
              <React.Fragment key={item.label}>
                <Box className={classes.boxItem}>
                  <FieldInfoNG label={item.label} isVertical>
                    {Array.isArray(item.value) ? (
                      item.value.map((val, idx) => (
                        <Typography key={idx} className={classes.description}>
                          {item?.label === 'Дополнительный телефон' ? val?.toString()?.toPhone() : val}
                        </Typography>
                      ))
                    ) : (
                      <Typography className={classes.description}>{item.value}</Typography>
                    )}
                  </FieldInfoNG>
                </Box>
                {(index + 1) % 5 === 0 && line && index !== data?.length - 1 && (
                  <Box gridColumn={`span ${currentColumns}`} className={classes.divider}>
                    <Divider />
                  </Box>
                )}
              </React.Fragment>
            ))
          ) : (
            <NotFound />
          )}
        </Box>
      </CardContent>
    </Card>
  )
}
